import * as React from "react";
import { size, lineHeight, fontFamily } from "@clockwise/web-commons/src/styles/type.styles";
import spacing from "@clockwise/web-commons/src/styles/spacing.styles";

const baseStyles: React.CSSProperties = {
  fontFamily,
  fontSize: size.lg,
  fontWeight: "bold",
  lineHeight: lineHeight.std,
  marginBottom: spacing.sm,
  paddingBottom: spacing.std,
};

export function H5(
  props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
) {
  const styles = Object.assign({}, baseStyles, props.style);
  const mergedProps = Object.assign({}, props, { style: styles });
  return <div {...mergedProps}>{props.children}</div>;
}
